var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"my-4"},[_c('img',{attrs:{"src":_vm.selectedOption.image,"alt":_vm.selectedOption.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }